import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppJobModule } from '../app-job/app-job.module';
import { ToolRoutingModule } from './app-tool.routing.module';
import { ReactiveFormsModule } from '@angular/forms';
// import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatButtonModule } from '@angular/material/button';
// import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
// import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
// import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core'; // Needed for DatePicker
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'; // Spinner module for Material progress spinner
import {
  MAT_DATE_FORMATS,
  DateAdapter,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { AppToolsGstInvoiceBuilderComponent } from './app-tools-gst-invoice-builder/app-tools-gst-invoice-builder.component';
import { AppToolsGstInvoiceBuilderService } from './app-tools-gst-invoice-builder/app-tools-gst-invoice-builder.service';

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD-MM-YYYY', // Parsing format
  },
  display: {
    dateInput: 'Do MMM, YYYY', // Desired display format
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@NgModule({
  declarations: [AppToolsGstInvoiceBuilderComponent],
  imports: [
    CommonModule,
    AppJobModule,
    ToolRoutingModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatDatepickerModule,
    MatNativeDateModule, // Required for Material Date Picker
    MatCardModule,
    MatToolbarModule,
    MatSelectModule,
    MatProgressSpinnerModule,
  ],
  providers: [
    MatDatepickerModule, // Ensure Datepicker is provided
    AppToolsGstInvoiceBuilderService,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ],
  exports: [],
  // entryComponents: [AppToolsGstInvoiceBuilderComponent],
})
export class AppToolsModule {}
